import shopTheLook from './rbata.shopTheLook';
import logger from '../utils/rbata.logger';
import spinner from '../utils/rbata.spinner';
import urlService from '../services/rbata.urlService';
import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';

const lookCreator = {
    pageBody: undefined,
    cacheSelectors() {
        this.pageBody = $(document.body);
    },

    fetchStlProducts(products) {
        if (!products) {
            return;
        }

        const request = $.ajax({
            url:         `${urlService.getBaseUrl()}lookcreatoroverlay/`,
            method:      'POST',
            dataType:    'html',
            contentType: 'application/json',
            data:        JSON.stringify({
                productCodes: products
            })
        });
        spinner.visibility(true);

        request.done((response) => {
            shopTheLook.digestAndRenderStlProducts(response, undefined);
            shopTheLook.stlModal.modal('show');
            spinner.visibility(false);
            mediaLazyLoad.refreshLazyLoad();
        });
        request.fail((jqXHR) => {
            logger.error(`${jqXHR.status} error in  look creator`);
        });
        request.always(() => {
            spinner.visibility(false);
        });
    },

    initSTLModal() {
        if (!shopTheLook.stlModal) {
            shopTheLook.stlModal = $('#stlModal');
            shopTheLook.$body    = $('body');
            shopTheLook.stlModal.on('hidden.bs.modal', shopTheLook.cleanupModal);
            shopTheLook.initCartHandlers();
        }
    }
};

$(() => {
    if ($('#look-creator-page').length) {
        lookCreator.cacheSelectors();
        lookCreator.initSTLModal();
        alphatauri.util.shopThisLook = lookCreator.fetchStlProducts;
    }
});

export default lookCreator;
